import {
  SnippetElement,
  defineElement,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/common-main-article/common-main-article.ts
var CommonMainArticle = class extends SnippetElement {
  connectedCallback() {
    var _a;
    this.calculateReadingTime(this.readingTime.getAttribute("data-article-reading-time"));
    (_a = this.videoPlayer) == null ? void 0 : _a.play();
    console.log("videoPlayer", this.videoPlayer);
  }
  calculateReadingTime(characterCount) {
    const charactersPerMinute = 1e3;
    const readingTime = Math.ceil(characterCount / charactersPerMinute);
    this.readingTime.innerHTML = readingTime.toString() + " Min.";
  }
};
__decorateClass([
  query("[data-article-reading-time]")
], CommonMainArticle.prototype, "readingTime", 2);
__decorateClass([
  query("video")
], CommonMainArticle.prototype, "videoPlayer", 2);
CommonMainArticle = __decorateClass([
  defineElement("common-main-article")
], CommonMainArticle);
export {
  CommonMainArticle
};
